<template>
  <header :class="{ 'scrolled': scrolled, 'mobile-menu-open': mobileMenuOpen }">
    <!-- 1. 新增：假刷新加载遮罩（默认隐藏） -->
    <div class="fake-refresh-mask" v-if="isRefreshing"></div>

    <!-- 顶部导航栏：社交图标改为点击事件 -->
    <div class="nav-top">
      <div class="container">
        <ul class="social-icons">
          <!-- 社交图标：替换router-link为li点击事件 -->
          <li @click="handleNavClick('contact', true)">
            <i class="fas fa-envelope"></i>
          </li>
          <li @click="handleNavClick('contact', true)">
            <i class="fab fa-instagram"></i>
          </li>
          <li @click="handleNavClick('contact', true)">
            <i class="fab fa-facebook"></i>
          </li>
          <!-- 语言切换：保持不变 -->
          <li class="language-switcher">
            <button @click="toggleLanguage" aria-label="切换语言">
              {{ $i18n.locale === 'zh' ? 'EN' : '中文' }}
            </button>
          </li>
        </ul>
      </div>
    </div>

    <!-- 主要导航栏：桌面端导航改为点击事件 -->
    <div class="nav-main">
      <div class="container">
        <div class="nav-content">
          <!-- Logo：跳转首页+假刷新 -->
          <div @click="handleNavClick('home')" class="logo" style="cursor: pointer;">
            <img src="../assets/blogo.png" alt="Company Logo" width="180">
          </div>
          <!-- 桌面端导航：替换router-link为li点击事件 -->
          <nav class="desktop-nav">
            <ul>
              <li @click="handleNavClick('home')">{{ $t('nav.home') }}</li>
              <li @click="handleNavClick('product')">{{ $t('nav.product') }}</li>
              <li @click="handleNavClick('contact')">{{ $t('nav.contact') }}</li>
              <li @click="handleNavClick('about')">{{ $t('nav.about') }}</li>
            </ul>
          </nav>
          <!-- 移动端菜单按钮：保持不变 -->
          <button class="mobile-menu-button" @click="toggleMobileMenu" aria-label="Toggle menu">
            <i class="fas fa-bars"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- 移动端菜单：替换router-link为li点击事件 -->
    <div class="mobile-menu">
      <nav>
        <ul>
          <li @click="handleNavClick('home', false, true)">{{ $t('nav.home') }}</li>
          <li @click="handleNavClick('product', false, true)">{{ $t('nav.product') }}</li>
          <li @click="handleNavClick('contact', false, true)">{{ $t('nav.contact') }}</li>
          <li @click="handleNavClick('about', false, true)">{{ $t('nav.about') }}</li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MyHeader',
  data() {
    return {
      mobileMenuOpen: false,
      scrolled: false,
      isRefreshing: false, // 新增：控制假刷新加载遮罩显示
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    // 从本地存储读取语言：保持不变
    const savedLang = localStorage.getItem('appLang');
    if (savedLang) {
      this.$i18n.locale = savedLang;
    }
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    handleScroll() {
      this.scrolled = window.scrollY > 10;
    },
    handleResize() {
      if (window.innerWidth >= 768 && this.mobileMenuOpen) {
        this.mobileMenuOpen = false;
      }
    },
    // 原有：获取路由配置（保持不变）
    getRoute(title) {
      switch (title) {
        case 'contact':
          return '/contact';
        case 'about':
          return '/about';
        case 'product':
          return { name: 'PdtList', params: { categoryId: 0 } };
        case 'home':
        default:
          return '/';
      }
    },
    toggleLanguage() {
      const newLang = this.$i18n.locale === 'zh' ? 'en' : 'zh';
      this.$i18n.locale = newLang;
      localStorage.setItem('appLang', newLang);
    },
    // 原有：社交图标移动端菜单关闭（整合到新方法，此处可删除）
    // handleSocialLinkClick() {},

    // 原有：空方法（可删除）
    // goContact() {},

    /**
     * 新增：处理路由点击（核心假刷新逻辑）
     * @param {string} routeName - 路由名称（home/product/contact/about）
     * @param {boolean} isSocialIcon - 是否是社交图标（需判断移动端菜单关闭）
     * @param {boolean} isMobileMenu - 是否是移动端菜单（点击后关闭菜单）
     */
    handleNavClick(routeName, isSocialIcon = false, isMobileMenu = false) {
      // 1. 触发假刷新：显示加载遮罩
      this.isRefreshing = true;

      // 2. 关闭移动端菜单（保留原有逻辑）
      if (isMobileMenu) {
        this.toggleMobileMenu();
      }
      if (isSocialIcon && window.innerWidth < 768 && this.mobileMenuOpen) {
        this.toggleMobileMenu();
      }

      // 3. 获取目标路由
      const targetRoute = this.getRoute(routeName);

      // 4. 路由跳转：完成后关闭加载遮罩
      this.$router.push(targetRoute)
          .then(() => {
            // 跳转成功：延迟300ms关闭（确保用户看到刷新效果，可调整时长）
            setTimeout(() => {
              this.isRefreshing = false;
              // 可选：跳转后滚动到顶部（模拟真实刷新的滚动行为）
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 300);
          })
          .catch((err) => {
            // 跳转失败：立即关闭加载遮罩（避免遮罩卡死）
            this.isRefreshing = false;
            console.error('路由跳转失败：', err);
          });
    },
  }
}
</script>

<style scoped>
/* 基础样式 - 保持不变 */
header {
  position: sticky;
  top: 0;
  z-index: 100;
  transition: background-color 0.3s ease;
  min-height: 140px;
  cursor: pointer;
}

.container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  box-sizing: border-box;
}

a {
  text-decoration: none;
  transition: color 0.2s ease;
}

/* 顶部导航栏 - 关键修复：社交图标容器垂直居中 */
.nav-top {
  background: gainsboro;
  font-size: 14px;
}

.nav-top .container,
.nav-main .container {
  padding: 0 2vw;
}

/* 修复1：社交图标容器添加align-items，确保所有子元素垂直居中 */
.social-icons {
  display: flex;
  justify-content: flex-end;
  align-items: center; /* 新增：垂直居中，避免按钮上下偏移 */
  list-style: none;
  margin: 0;
  padding: 0; /* 重置默认内边距 */
}

.social-icons li {
  margin-left: 15px;
  line-height: 1; /* 新增：统一行高，避免文本垂直偏移 */
}

/* 社交图标链接样式 - 保持不变 */
.social-icons li a {
  color: #333;
  padding: 12px 0;
  display: inline-block;
  line-height: 1; /* 统一行高 */
}

/* 修复2：语言切换按钮独立样式（核心！） */
.language-switcher button {
  background: none;
  border: none; /* 移除默认边框 */
  outline: none; /* 移除点击outline */
  color: #333;
  padding: 12px 8px; /* 新增左右padding，平衡文本长度差异 */
  margin: 0;
  cursor: pointer;
  font-size: 14px;
  transition: color 0.2s ease;
  line-height: 1; /* 固定行高，避免文本换行 */
  text-align: center; /* 文本居中 */
  min-width: 40px; /* 新增最小宽度，避免切换时宽度突变 */
}

/* 修复3：按钮hover样式与图标统一 */
.language-switcher button:hover {
  color: #337ab7;
  /* 无额外边距/ padding变化，避免hover时跳动 */
}

.social-icons li a:hover {
  color: #337ab7;
}

/* 主要导航栏 - 保持不变 */
.nav-main {
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.nav-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
}

.logo {
  display: block;
}

.logo img {
  max-height: 50px;
  width: auto;
}

/* 桌面端导航 - 保持不变 */
.desktop-nav {
  display: none;
}

@media (min-width: 768px) {
  .container {
    max-width: 80%;
    padding: 0 15px;
  }

  .nav-top .container,
  .nav-main .container {
    padding: 0 15px;
  }

  .desktop-nav {
    display: block;
  }

  .desktop-nav ul {
    display: flex;
    align-items: center;
    gap: clamp(1.5rem, 3vw, 2.5rem);
    list-style: none;
    margin: 0;
    padding: 0;
    margin-left: auto;
  }

  .desktop-nav ul li a {
    color: #333;
    font-weight: bold;
    padding: 10px 0;
    position: relative;
  }

  .desktop-nav ul li a::after {
    content: '';
    position: absolute;
    width: 0;
    height: 2px;
    bottom: -2px;
    left: 0;
    background-color: #337ab7;
    transition: width 0.3s ease;
  }

  .desktop-nav ul li a:hover {
    color: #337ab7;
  }

  .desktop-nav ul li a:hover::after {
    width: 100%;
  }

  .mobile-menu-button {
    display: none;
  }
}

/* 移动端菜单按钮 - 保持不变 */
.mobile-menu-button {
  background: none;
  border: none;
  font-size: 24px;
  color: #333;
  cursor: pointer;
  display: block;
  line-height: 1;
}

/* 移动端菜单 - 保持不变 */
.mobile-menu {
  background: white;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-10px);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  overflow-x: hidden;
}

.mobile-menu-open .mobile-menu {
  transform: translateY(0);
  opacity: 1;
  visibility: visible;
}

.mobile-menu ul {
  padding: 15px;
  list-style: none;
  margin: 0;
}

.mobile-menu ul li {
  margin-bottom: 15px;
}

.mobile-menu ul li a {
  color: #333;
  font-weight: bold;
  display: block;
  padding: 10px 0;
}

.mobile-menu ul li a:hover {
  color: #337ab7;
}

/* 滚动效果 - 保持不变 */
.scrolled .nav-main {
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.scrolled .nav-content {
  padding: 10px 0;
}

.scrolled .logo img {
  max-height: 45px;
}
/* 假刷新加载遮罩：全屏半透明+加载动画 */
.fake-refresh-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.8); /* 白色半透明背景 */
  z-index: 9999; /* 确保在最顶层（高于导航的z-index:100） */
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.2s ease;
}

/* 加载动画（旋转圆圈） */
.fake-refresh-mask::after {
  content: '';
  width: 40px;
  height: 40px;
  border: 4px solid #eee;
  border-top-color: #337ab7; /* 主题色 */
  border-radius: 50%;
  animation: spin 0.8s linear infinite; /* 旋转动画 */
}

/* 旋转动画关键帧 */
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
